import { DealDetails } from '@/classes/DealDetails'
import { defineStore } from 'pinia'

export const globalStore = defineStore('global', {
  state: () => ({
    isFocusedOnInput: false,
    searchQuery: '',
    searchSuggestions: [] as string[],
    maxPrice: 0,
    minPercentOff: 50,
    categoryNodes: [] as string[],
    selectedDeal: null as DealDetails | null,
    showDealPrice: true,
    showModalDealAlerts: false
  }),
  actions: {
    setFocusedOnInput(value: boolean) {
      this.isFocusedOnInput = value
    },
    setSearchQuery(value: string) {
      this.searchQuery = value
    },
    setSearchSuggestions(value: string[]) {
      this.searchSuggestions = value
    },
    setMaxPrice(value: number) {
      this.maxPrice = value
    },
    setMinPercentOff(value: number) {
      this.minPercentOff = value
    },
    setCategoryNodes(value: string[]) {
      this.categoryNodes = value
    },
    clearCategoryNodes() {
      this.categoryNodes = []
    },      
    loadSearchParamsFromLocalStorage() {
      try {
        const savedParams = localStorage.getItem('searchParams');
        console.log('savedParams', savedParams)
        if (savedParams) {
          const params = JSON.parse(savedParams);
          if (params.maxPrice) this.setMaxPrice(params.maxPrice);
          if (params.minPercentOff) this.setMinPercentOff(params.minPercentOff);
        }
      } catch (error) {
        console.error('Error loading search parameters from localStorage:', error);
      }
    },
    setSelectedDeal(deal: DealDetails, showPrice: boolean = true) {
      this.selectedDeal = deal
      this.showDealPrice = showPrice
    },
    setShowModalDealAlerts(value: boolean) {
      this.showModalDealAlerts = value
    }
  }
})